import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@common/components/ui/dialog"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { QuoteForm } from "@/routes/_layout/quoting_/quotes/-components/quote-form"

export const Route = createFileRoute("/_layout/quotes/create")({
  component: CreateQuoteModal,
})

function CreateQuoteModal(): React.ReactElement {
  const navigate = useNavigate()

  const close = () => navigate({ to: "/quotes", search: true })

  return (
    <Dialog open onOpenChange={(open) => !open && close()}>
      <DialogContent className="max-h-[calc(100vh-2rem)] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>New quote</DialogTitle>
        </DialogHeader>
        <QuoteForm
          onCreate={(quote) =>
            navigate({
              to: "/quotes/$quoteId",
              params: { quoteId: quote.id },
            })
          }
        />
      </DialogContent>
    </Dialog>
  )
}
